import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";

import { ClientContextDto, clientContextSchema } from "./diets/creator";

export const postPatientRecipesContext = async (
  patientId: string,
  payload: number[],
): Promise<ApiResponse<RecipeContextDto[]>> => {
  const response = await fetchData(
    `/dietitian/patients/${patientId}/recipes-context`,
    APIMethods.POST,
    { ids: payload },
  );

  return postPatientRecipesContextResponseSchema.validate(response);
};

export interface RecipeContextDto {
  id: number;
  clientContext: ClientContextDto;
}

const recipeContextSchema = yup.object({
  id: yup.number().required(),
  clientContext: clientContextSchema.required(),
});
const postPatientRecipesContextResponseSchema = yup.object({
  data: yup.array().of(recipeContextSchema).required(),
});
